module.exports = __webpack_public_path__ + "img/sp-nav-act.79a8c6f7.png";